export enum UserShowField {
  displayLanguage = 1,
  displaySubject = 2,
  displayBody = 4,
  displayAttachment = 8,
  displayDocuments = 16
}

export enum SupportedLanguageList {
  'en',
  'da',
  'de',
  'es',
  'fr',
  'it',
  'pt',
  'ro',
  'sv',
  'el',
  'bg',
  'ru',
  'zh-CN',
  'zh-TW'
}
